export const firmware = {
  newFirmwareAvailable: "New firmware is available:",
  M3502PD: "M350 2PD + DSS - v{0}",
  M3503PD: "M350 3PD - v{0}",
};
